import React, { Component } from 'react'
import ConsultaCrud from '../../../../../components/ConsultaCrud'


import { FiltroStringScorpion } from 'scorpion-core'


export default class ConsultaPerfisAdmin extends Component {
    componentDidMount() {
        this.props.listar();

    }
    render() {
        const { lista, loading, history } = this.props;
        const titulo = "Perfis"
        const tipoModeloRelatoriosUnico = "PerfilUnico"
        const tipoModeloRelatoriosMultipos = "PerfilMultiplo"
        const novo = () => history.push("/PerfilUser");
        const editar = (obj) => history.push({ pathname: "/PerfilUser", state: { initialValuesUsar: obj } })


        let colunas = [
            { label: "Nome", getValue: item => item.nome, },
            { label: "Email", getValue: item => item.email, },
        ];
        let styleFiltros = { flex: 1, padding: 5 }
        return (
            
                <ConsultaCrud
                    titulo={titulo}
                    tipoModeloRelatoriosUnico={tipoModeloRelatoriosUnico}
                    tipoModeloRelatoriosMultipos={tipoModeloRelatoriosMultipos}
                    loading={loading}
                    lista={lista}
                    colunas={colunas}
                    editar={editar}
                >
                    <FiltroStringScorpion name="filtroNome" label="Nome"
                        style={styleFiltros}
                        strComparaLike={item => item.nome}
                        criaSugestaoPorLike={lista} />
                    <FiltroStringScorpion name="filtroEmail" label="Email"
                        style={styleFiltros}
                        strComparaLike={item => item.email}
                        criaSugestaoPorLike={lista} />
                </ConsultaCrud>
            
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/admin/ConsultaPerfisAdmin/componentes/ConsultaPerfisAdmin/ConsultaPerfisAdmin.js